import { createApp } from 'vue'; import { createPinia } from 'pinia'; import App from './App.vue'; import router from './router'; import './styles/theme.css'; import './styles/global.css'; import './styles/pages.css'; import './styles/dialogs.css';
createApp(App).use(createPinia()).use(router).mount('#app');
